import { StepSequencerState } from "@/store/types/step-sequencer.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import * as Tone from "tone";

export const state: StepSequencerState = {
  synth: new Tone.PolySynth(Tone.Synth, { oscillator: { type: "square" } }).toDestination(),
  chords: [],
  colors: [
    "#cf4c4c",
    "#846d21",
    "#248c46",
    "#f34b88",
    "#c66735",
    "#5f8d35",
    "#19a085",
    "#f16669"
  ],
  notes: ["C3", "D3", "E3", "F3", "G3", "A3", "B3", "C4"],
  selected: [],
  currentChord: [],
  currentChordN: 0,
  started: false
};

const namespaced = true;

export const StepSequencerModule: Module<StepSequencerState, RootState> = {
  namespaced,
  actions,
  getters,
  mutations,
  state
};
